import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // 추가
import axios from 'axios';

const News = () => {
  const [newsList, setNewsList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = window.innerWidth < 768 ? 6 : 9;
  const navigate = useNavigate(); // 추가

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get('http://plassion.co.kr:8444/api/get/board_list', {
          params: {
            cate: 'news',
            page: currentPage,
            pageSize: itemsPerPage,
          },
        });
        setNewsList(response.data.data);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        console.error('Error fetching news data:', error);
      }
    };
    fetchNews();
  }, [currentPage]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0); // 페이지 최상위로 스크롤
  };

  const handleFirstPage = () => {
    paginate(1);
  };

  const handleLastPage = () => {
    paginate(totalPages);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      paginate(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      paginate(currentPage - 1);
    }
  };

  const handleDetailClick = (idx) => {
    navigate(`/board/news/${idx}`); // 상세 페이지로 이동
  };

  return (
    <div className="news-wrap">
      <div className="news-intro-title">플레이션의 소식을 전해드립니다!</div>
      <div className="news-grid">
        {newsList.map((news, index) => (
          <div className="news-box" key={index}>
            <div className="image-container">
              <img src={`http://plassion.co.kr:8444/uploads/${news.img1}`} alt={news.title} />
              <div className="news-hover" onClick={() => handleDetailClick(news.idx)}>
                <p>상세보기</p>
              </div>
            </div>
            <div className="news-content">
              <h3>{news.title}</h3>
              <p>{news.content.replace(/<[^>]+>/g, '')}</p>
              <p className="last-txt">
                {news.writer} &nbsp;{new Date(news.date).toISOString().split('T')[0]} &nbsp;조회수: {news.hit}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="pagination">
        <button onClick={handleFirstPage} disabled={currentPage === 1}>
          {'<<'}
        </button>
        <button onClick={handlePreviousPage} disabled={currentPage === 1}>
          {'<'}
        </button>
        {[...Array(totalPages)].map((_, i) => (
          <button key={i} onClick={() => paginate(i + 1)} className={currentPage === i + 1 ? 'active' : ''}>
            {i + 1}
          </button>
        ))}
        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
          {'>'}
        </button>
        <button onClick={handleLastPage} disabled={currentPage === totalPages}>
          {'>>'}
        </button>
      </div>
    </div>
  );
};

export default News;
